import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from './streamApi';

// Support access status of this box (PRVSK-109): is the built-in support login
// switched on, until when. Read by the banner on every page and by the Support
// page. Polls every 60 s; the Support page fires SUPPORT_ACCESS_CHANGED after
// turning it on or off so the banner updates at once.
export const SUPPORT_ACCESS_CHANGED = 'prvsk:support-access-changed';
const POLL_MS = 60000;

export const fmtUntil = ts => {
  if (!ts) return '';
  const d = new Date(ts * 1000);
  const sameDay = d.toDateString() === new Date().toDateString();
  return sameDay
    ? d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleString([], { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
};

export function useSupportAccess() {
  const [st, setSt] = useState(null);
  const load = useCallback(async () => {
    try {
      const r = await apiFetch('/support/access');
      // 404: an older box, or App Support switched off on this one.
      if (r.status === 404) setSt({ unsupported: true, active: false });
      else if (r.ok) setSt(await r.json());
    } catch { /* offline — keep what we last knew */ }
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, POLL_MS);
    window.addEventListener(SUPPORT_ACCESS_CHANGED, load);
    return () => { clearInterval(t); window.removeEventListener(SUPPORT_ACCESS_CHANGED, load); };
  }, [load]);
  return [st, load];
}

export async function turnSupportAccessOff() {
  const r = await apiFetch('/support/access', { method: 'DELETE' });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || `HTTP ${r.status}`);
  window.dispatchEvent(new Event(SUPPORT_ACCESS_CHANGED));
}
